import UtmCampaign from 'pages/UtmCampaign/container';

export default UtmCampaign;
